<template>
	<div class="weibo-system">
		<section class="weibo-system__card">
			<h1>微博接入</h1>
			<div>
				<span class="iconfont major-weibo1"></span>
				<div>
					<h4>绑定后你可以使用微博私信</h4>
					<p>你的公众号必须是认证过的微信订阅号/服务号</p>
					<p>绑定后，之前在公众平台设置好的菜单和自动回复功能将失效，你需要在OCS+重新设置。<a href="" target="_blank">查看帮助文档</a></p>
				</div>
				<el-button type="primary" icon="el-icon-plus" plain size="small" @click="onBind()">绑定企业微博账号</el-button>
			</div>
		</section>
		<section class="weibo-system__table">
			<h1>已绑定列表</h1>
			<table-pagination v-loading="loading" ref="tableItem"  :data="data"
				:column="column" >
				<template v-slot:action="{row}">
					<el-button type="text" size="small" @click="onBasic(row)">基础设置</el-button>
					<el-divider direction="vertical"></el-divider>
					<el-button type="text" size="small" @click="onAdvanced(row)">高级设置</el-button>
					<el-divider direction="vertical"></el-divider>
					<el-button type="text" size="small" @click="onUnbind(row)">解绑</el-button>
				</template>
			</table-pagination>
		</section>
		<!-- 绑定企业微博 -->
		<BindView v-model="bindViewer.show" :source="bindViewer.source" @getList="getList"/>
		<!-- 基础设置 -->
		<BasicView v-model="basicViewer.show" :source="basicViewer.source" @getList="getList"/>
		<!-- 高级设置 -->
		<AdvancedView v-model="advancedViewer.show" :source="advancedViewer.source"/>
	</div>
</template>

<script>
	import BindView from './bind/index.vue';
	import BasicView from './basic/index.vue';
	import AdvancedView from './advanced';
	export default {
		components:{
			BindView,
			BasicView,
			AdvancedView
		},
		data() {
			return {
				loading:false,
				data: [],
				column: [{
						label: "微博名称",
						prop: "weiboName"
					},
					{
						label: "微博ID",
						prop: "weiboId",
						render:(h,scope) => {
							return <el-button type="text" onClick={() => this.onBind(scope.row)}>{scope.row.weiboId}</el-button>
						}
					},
					{
						label: '绑定时间',
						prop: 'updateTime',
						sortable: true,
						render:(h,scope) => {
							return <span>{scope.row.updateTime ? this.$dayjs(scope.row.updateTime).format("YYYY-MM-DD HH:mm") : '--'}</span>
						}
					},
					{
						label: "操作",
						prop: "action",
						slotScope: true,
						width: 200,
						align: "center",
					}
				],
				bindViewer:{
					show:false,
					source:null,
				},
				basicViewer:{
					show:false,
					source:null
				},
				advancedViewer:{
					show:false,
					source:null
				}
			}
		},
		methods: {
			getList(){
				this.loading = true;
				this.$api.getWeiboListForSystem().then(res => {
					this.loading = false;
					if(res.errcode != 0) return;
					this.data = res.data;
				})
			},
			// 基础设置
			onBasic(row){
				this.basicViewer = {
					show:true,
					source:row
				}
			},
			// 高级设置
			onAdvanced(row){
				this.advancedViewer = {
					show:true,
					source:row
				}
			},
			// 微博绑定
			onBind(row){
				this.bindViewer = {
					show:true,
					source:row || null
				}
			},
			// 解绑
			onUnbind(row){
				this.$confirm(`请前往微博帐号“管理中心”－“粉丝服务”－“开发者中心”进行停用。解绑后，OCS+将无法收到来自微博【${row.weiboName}】的私信，是否要解绑`, "解绑提醒", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
						type: "warning",
						center: true,
						customClass: "confirm-element-model"
					})
					.then(() => {
						this.$api.unbindWeiboForSystem({
							weiboid:row.weiboId
						}).then(res => {
							if(res.errcode == 0){
								this.$message.success("解绑成功");
								this.getList()
							}
						})
						
					})
					.catch(() => {
						this.$message.info('取消解绑')
					});
			}
			
		},
		mounted(){
			this.getList()
		}
	}
</script>

<style lang="scss" scoped>
	.weibo-system {
		font-size: 14px;

		h1 {
			color: #3C4353;
			margin-bottom: 16px;
			font-size: 14px;
		}

		&__card {
			>div {
				padding: 20px 30px;
				box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.03);
				border-radius: 3px;
				border: 1px solid #DEDFDF;
				display: flex;
				align-items: center;
				position: relative;

				.iconfont {
					font-size: 40px;
					color: #337EFF;
				}

				>div {
					display: inline-block;
					margin-left: 31px;
					vertical-align: middle;

					h4 {
						color: #3C4353;
						font-weight: 500;
						margin-bottom: 16px;
					}

					p {
						color: #566980;
						font-size: 12px;
						line-height: 22px;
					}

					a {
						color: #337EFF;
					}
				}

				.el-button {
					position: absolute;
					right: 30px;
				}
			}
		}
		&__table {
			margin-top: 30px;
		}
	}
</style>
